import { Route, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { OrderStatusFormComponent } from './core/components/order-status-form/order-status-form.component';
import { ReturnRequestRmaFormComponent } from './shared/components/return-request-rma-form/return-request-rma-form.component';
import { CartPageComponent } from './core/components/cart-page/cart-page.component';
import { StorePolicyPageComponent } from './store/store-policy-page/store-policy-page.component';
import { SearchEntryComponent } from './entry/components/search-entry/search-entry.component';
import { RootEntryComponent } from './entry/components/root-entry/root-entry.component';
import { ProductPageComponent } from './product/components/product-page/product-page.component';
import { CollectionPageComponent } from './collection/collection-page/collection-page.component';
import { NotFoundComponent } from './shared/components/not-found/not-found.component';
import { ProductResolver } from './core/providers/product-resolver';
import { CollectionResolver } from './core/providers/collection-resolver';
import { PolicyResolver } from './core/providers/policy-resolver';
import { UnderConstructionPageComponent } from './shared/components/under-construction-page/under-construction-page.component';
import { NGXLogger } from 'ngx-logger';
import { GeneralEntryComponent } from './entry/components/general-entry/general-entry.component';
import { PageResolver } from './core/providers/page-resolver';
import { PromoLinkResolver } from './core/providers/promo-link-resolver';
import { PromotionLinkComponent } from './core/components/promotion-link/promotion-link.component';
import { StorePrefixRemoverGuard } from './core/guards/store-prefix-remover.guard';
import { EmptyRouteComponent } from './core/components/empty.component';

export const routes: Route[] = [
    {
        path: 'store/:identifier',
        children: [
          {
            path: '',
            component: EmptyRouteComponent,
            canActivate: [StorePrefixRemoverGuard],
            pathMatch: 'full'
          },
          {
            path: '**',
            component: EmptyRouteComponent,
            canActivate: [StorePrefixRemoverGuard]
          }
        ]
      },
    {
        path: '',
        component: RootEntryComponent,
        pathMatch: 'full',
        resolve: { pageData: PageResolver },
        runGuardsAndResolvers: 'always',
    },
    {
        path: 'under-construction',
        component: UnderConstructionPageComponent,
    },
    {
        path: 'return-form',
        component: ReturnRequestRmaFormComponent,
    },
    {
        path: 'dp/:slug',
        component: ProductPageComponent,
        resolve: { productPage: ProductResolver },
        runGuardsAndResolvers: 'always',
    },
    {
        path: 'gp/:slug',
        component: CollectionPageComponent,
        resolve: { collectionPage: CollectionResolver },
        runGuardsAndResolvers: 'always',
    },
    {
        path: 'search',
        component: SearchEntryComponent,
    },
    {
        path: 'checkout',
        loadChildren: () => import('./checkout/checkout.module').then(m => m.CheckoutModule),
    },
    {
        path: 'cart',
        component: CartPageComponent,
    },
    {
        path: 'account',
        loadChildren: () => import('./account/account.module').then(m => m.AccountModule),
    },
    {
        path: 'promocode/:promocode',
        component: PromotionLinkComponent,
        resolve: { promotionData: PromoLinkResolver }
    },
    {
        path: 'orderstatus',
        component: OrderStatusFormComponent,
    },
    {
        path: 'store-policy/:policy',
        component: StorePolicyPageComponent,
        resolve: { policyData: PolicyResolver }
    },
    {
        path: 'not-found',
        component: NotFoundComponent,
    },
    {
        path: '**',
        component: GeneralEntryComponent,
        resolve: { pageData: PageResolver },
        runGuardsAndResolvers: 'always',
    }
];


@NgModule({
    imports: [RouterModule.forRoot(routes, { initialNavigation: 'enabledBlocking' ,  enableTracing: false})],
    exports: [RouterModule]
  })
  export class AppRoutingModule {
    constructor(private logger: NGXLogger) {
        this.logger.debug('AppRoutingModule loaded');
    }
}
